var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow"},[_c('div',{staticClass:"flow-item"},[_c('img',{staticClass:"flow-icon",attrs:{"src":_vm.icon}}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.arrorImg)?_c('img',{staticClass:"flow-arror",attrs:{"src":_vm.arrorImg,"alt":""}}):_vm._e()]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }